import WOW from 'wowjs';
import NiceSelect from './nice-select2';

window.WOW = WOW.WOW;
window.NiceSelect = NiceSelect;